// extracted by mini-css-extract-plugin
module.exports = {"results":"SearchFilterResults_results__194M0","search_result":"SearchFilterResults_search_result__3MAIC","type":"SearchFilterResults_type__6CeBq"};